(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-footer"] && !Shopify.designMode) return;
  try {
    
  // Auto-submit the localization form when the country/region selector changes —
  // Shopify's standard pattern for the storefront locale switcher.
  document.querySelectorAll('.oc-footer__locale-form--js').forEach((form) => {
    const select = form.querySelector('select[name="country_code"]');
    if (!select) return;
    select.addEventListener('change', () => form.submit());
  });

  // On mobile, the menu columns use <details> as accordions; on desktop they're always
  // expanded. The `open` attribute toggles per the spec ≥1024px = open, <1024px = collapsed.
  // Use a single matchMedia listener instead of per-element ResizeObserver.
  (function () {
    const accordions = document.querySelectorAll('[data-oc-acc]');
    if (!accordions.length) return;
    const mq = window.matchMedia('(min-width: 1024px)');
    const sync = () => {
      accordions.forEach((d) => {
        if (mq.matches) {
          d.open = true;
        } else if (!d.dataset.ocUserToggled) {
          d.open = false;
        }
      });
    };
    accordions.forEach((d) => {
      d.addEventListener('toggle', () => {
        if (!mq.matches) d.dataset.ocUserToggled = '1';
      });
    });
    if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-pallet-math"] && !Shopify.designMode) return;
  try {
    
  // "How long will one pallet last" — bottles ÷ (people × bottles per person per day).
  // Deliberately dependency-free and re-runnable so the theme editor can reload the
  // section without leaving stale listeners behind.
  (function () {
    function init(root) {
      var calc = root.querySelector('[data-oc-calc]');
      if (!calc || calc.dataset.ocCalcReady === '1') return;
      calc.dataset.ocCalcReady = '1';

      var bottles = parseInt(calc.dataset.bottles, 10) || 0;
      var people = calc.querySelector('[data-oc-calc-people]');
      var rate = calc.querySelector('[data-oc-calc-rate]');
      var peopleOut = calc.querySelector('[data-oc-calc-people-out]');
      var rateOut = calc.querySelector('[data-oc-calc-rate-out]');
      var result = calc.querySelector('[data-oc-calc-result]');
      if (!people || !rate || !result) return;

      var unitOne = calc.dataset.daysLabelOne || 'workday';
      var unitMany = calc.dataset.daysLabelMany || 'workdays';

      function render() {
        var p = parseInt(people.value, 10) || 1;
        var r = parseInt(rate.value, 10) || 1;
        if (peopleOut) peopleOut.textContent = p;
        if (rateOut) rateOut.textContent = r;

        var days = Math.floor(bottles / (p * r));
        if (days < 1) days = 1;

        var unit = days === 1 ? unitOne : unitMany;
        var text = '1 pallet = ~' + days + ' ' + unit + ' for ' + p + (p === 1 ? ' person' : ' people');

        // Past a couple of weeks the day count stops being intuitive, so add a
        // rough calendar span alongside it (5 workdays to the week).
        if (days >= 10) {
          var weeks = Math.round(days / 5);
          text += ' · ≈ ' + weeks + (weeks === 1 ? ' week' : ' weeks');
        }
        result.textContent = text;
      }

      people.addEventListener('input', render);
      rate.addEventListener('input', render);
      render();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.oc-pmath').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
